/* The protected-checkout total: discounted merchandise + standard shipping +
   Route's current quote (or its existing cart line), never both protection fees.
   Reads only presentation data; checkout and Route handlers remain authoritative. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else api.mount(root);
})(typeof window !== 'undefined' ? window : this, function () {
  'use strict';
  function total(merch, shipping, routeInCart, routeQuote) {
    var protection = Number.isFinite(routeQuote) && routeQuote >= 0 ? routeQuote : routeInCart;
    return merch + shipping + protection;
  }
  function mount(win) {
    var scheduled = false;
    function claimed() {
      try { return win.localStorage.getItem('antiFreeShipClaimed') === 'true' && win.sessionStorage.getItem('antiFreeShipSession') === 'true'; }
      catch (_) { return false; }
    }
    function money(cents, currency) {
      return new Intl.NumberFormat(win.document.documentElement.lang || 'en-US', { style: 'currency', currency: currency }).format(cents / 100);
    }
    function apply() {
      var receipt = win.document.querySelector('[data-cc-receipt]');
      if (!receipt) return;
      var data = receipt.dataset, currency = data.currency;
      var merch = Number(data.merchCents), shipping = Number(data.shippingCents), route = Number(data.routeCents);
      if (!currency || ![merch, shipping, route].every(Number.isFinite)) return;
      var widget = receipt.closest('.cc-cart__foot').querySelector('route-cart-preferred');
      var amount = widget && widget.getAttribute('total-amount');
      var quoteCurrency = widget && widget.getAttribute('currency-code');
      var quote = amount !== null && amount !== '' && (!quoteCurrency || quoteCurrency === currency) ? Math.round(Number(amount) * 100) : NaN;
      if (claimed()) shipping = 0;
      var amountEl = receipt.querySelector('[data-cc-receipt-total]');
      var shipEl = receipt.querySelector('[data-cc-receipt-shipping]');
      var next = money(total(merch, shipping, route, quote), currency);
      if (amountEl && amountEl.textContent !== next) amountEl.textContent = next;
      if (shipEl && (data.shippingKnown === 'true' || claimed())) {
        var shipText = shipping === 0 ? 'Free' : money(shipping, currency);
        if (shipEl.textContent !== shipText) shipEl.textContent = shipText;
      }
    }
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      win.setTimeout(function () { scheduled = false; apply(); }, 16);
    }
    if (win.document.readyState === 'loading') win.document.addEventListener('DOMContentLoaded', schedule);
    else schedule();
    // Cart section swaps, delayed Route quotes and quantity/discount refreshes.
    new win.MutationObserver(schedule).observe(win.document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['total-amount', 'currency-code'] });
    win.addEventListener('storage', schedule);
    win.addEventListener('pageshow', schedule);
  }
  return { total: total, mount: mount };
});
